import React, { useMemo, useState } from 'react';
import './Homepage.css';

export const Homepage: React.FC = () => {
    const [activeTab, setActiveTab] = useState('home');

    const tabs = [
        { id: 'home', label: 'Home' },
        { id: 'about', label: 'About' },
        { id: 'contact', label: 'Contact' }
    ];

    const profilePicture = useMemo(() => {
        switch (activeTab) {
            case 'home': return "https://cdn.discordapp.com/avatars/174564916563279872/e04e02aeff234fcca85b1e534811b05b.webp"
            case 'about': return "https://cdn.discordapp.com/avatars/303996389816401930/3507fc1959a410cb6d695a860d91c90e.webp"
            case 'contact': return "https://cdn.discordapp.com/avatars/230027922650562573/d2d9d9fc74c2b4dae450219664d91b0b.webp"
        }
    }, [activeTab]);

    return (
        <div className="homepage">
            <nav className="navbar">
                <div className="nav-tabs">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            className={`nav-tab ${activeTab === tab.id ? 'active' : ''}`}
                            onClick={() => setActiveTab(tab.id)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
            </nav>

            <main className="content">
                {activeTab === 'home' && <section><h1>Home</h1><p>Welcome to the homepage</p></section>}
                {activeTab === 'about' && <section><h1>About</h1><p>Learn more about us</p></section>}
                {activeTab === 'contact' && <section><h1>Contact</h1><p>Get in touch with us</p></section>}
            </main>


            <div>
                <img className="profile-picture spin" src={profilePicture} alt="Profile"/>
            </div>
        </div>
    );
};

export default Homepage;